import React, {useEffect, useState} from 'react';
import { Form, Input } from 'antd';
import SPSelectWithEnum from "../../../base/SPSelectWithEnum";
const USED = 1

interface PropsType {
    enums: any
}

const DepreciationCost: React.FC<PropsType> = (props) => {
    const { enums } = props
    const form = Form.useFormInstance();
    const [ needDepreciate, setNeedDepreciate ] = useState<any>('')
    const [ maintenanceAmount, setMaintenanceAmount ] = useState('')
    const onDepreciateChange = (e: any) => {
        setNeedDepreciate(e)
    }


    useEffect(() => {
        setNeedDepreciate(form?.getFieldValue(['depreciate', 'used']))
    }, [form?.getFieldValue(['depreciate', 'used'])]);

    return (
        <>
            <Form.Item noStyle name={['depreciate', 'used']}  style={{
                width: '300px' }}>
                <SPSelectWithEnum style={{
                    width: '300px' }} onChange={onDepreciateChange} enums={enums} enumKey={'is_used'}
                ></SPSelectWithEnum>
            </Form.Item>
            {
                needDepreciate === USED ?
                    <div>
                        <div>根据车辆定损情况及保险公司定损金额</div>
                        维修费在
                        <Form.Item rules={[{ required: true, message: '请选择服务类型' }]} noStyle name={['depreciate', 'amount']} style={{display: 'inline-block'}}>
                            <Input disabled
                                   style={{
                                       width: '100px'
                                   }}
                            ></Input>
                        </Form.Item>
                        元以下不收折旧费
                        <div>
                            维修费在{form.getFieldValue(['depreciate', 'amount'])}元及以上,收维修费的
                            <Form.Item rules={[{ required: true, message: '请选择' }]} noStyle name={['depreciate', 'percent']}  style={{display: 'inline-block'}}>
                                <SPSelectWithEnum style={{
                                    width: '100px'
                                }} enums={enums} enumKey={'f_fepreciation_service_percentage'}
                                ></SPSelectWithEnum>
                            </Form.Item>
                            作为折旧费
                        </div>

                    </div>
                    : null
            }
        </>
    )
}

export default DepreciationCost;


